import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { POST_STATUS, s3Link } from '../utils/constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useToasts } from 'react-toast-notifications';

import PayPerViewText from '../images/pay-white-logo.png';
import TickSmallCheck from '../images/tick_small_edit.png';
import DollarEye from '../images/dollar-eye.png';
import EditPencil from '../images/edit-pencil.png';
import { useHistory } from 'react-router';


const minAmount = 3.99;
const userInformation = JSON.parse(localStorage.getItem('user'));

const PayPerViewModal = ({ show, setShowModal, user, conversation }) => {
    const history = useHistory();

    const { addToast } = useToasts();

    const [amount, setAmount] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const handleClose = () => setShowModal(false);

    const handleAmountChange = (e) => {
        const value = e.target.value;
        if (value < minAmount || isNaN(value)) {
            setError({
                ...error,
                amount: `Please enter a value greater than or equal to $${minAmount}`
            });
        } else {
            setError({
                ...error,
                amount: ''
            });
        }

        const formattedPrice = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        }).replace(/[^.\d]/g, '');

        setAmount(formattedPrice);
    };

    const handleMessageChange = (e) => {
        const value = e.target.value;
        setMessage(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message) {
            setError({
                ...error,
                message: 'Please enter a message'
            });

            return;
        }
        setIsLoading(true);

        await axios.post('/api/messages', {
            sender_id: userInformation.id, // su
            rec_id: user.id, // pu
            message: message,
            ppv_request: true,
            amount: amount,
        }).then(response => {
            handleClose();
            addToast('Request sent to user', { appearance: 'success', autoDismiss: true });
            history.push(`/messages?conversation_id=${conversation.id}`);
        }).catch(error => {
            addToast('Unable to process request', { appearance: 'error', autoDismiss: true });
        })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <Modal className="payperview-modal" show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title><LazyLoadImage src={PayPerViewText} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center payperview-wrapper">
                        <div className="comp-text">Request custom <span>Pay Per View</span></div>
                        <div className="user-name-price">
                            <span>content from </span><span className="user-name">@{user.login}</span>
                        </div>
                        <div className="comp-text"> <i>No payment shall be made from you as this is just a request </i> </div>
                        <div className="card-imgusr">
                            <div className="card-in">
                                {
                                    user.profile_pic ? <LazyLoadImage src={`${s3Link}/${user.id}/profile_photo.jpg`} /> : <div
                                        style={{
                                            width: 'auto',
                                            height: '50px',
                                            fontSize: '50px',
                                            color: '#0097FE',
                                            borderRadius: '50%',
                                            background: '#ffffff',
                                        }}
                                    >
                                        <i className="fa-solid fa-circle-user"></i>
                                    </div>
                                }
                            </div>
                            <span className="chek">
                                <LazyLoadImage src={TickSmallCheck} />
                            </span>
                        </div>
                        <div className="cust-box">
                            <form id="sendppv-form" onSubmit={handleSubmit}>
                                <div className="outer-border">
                                    <div className="head-out">
                                        <p><LazyLoadImage src={DollarEye} /> Offer price $ (USD):</p>
                                    </div>
                                    <div className="in-text">
                                        <input
                                            type="text"
                                            id="ppv_amount"
                                            name="ppv_amount"
                                            placeholder="0"
                                            value={amount}
                                            onChange={handleAmountChange}
                                        />
                                        {
                                            error.amount && <label id="num_error" className="error">{error.amount}</label>
                                        }
                                    </div>
                                </div>
                                <div className="outer-border">
                                    <div className="head-out">
                                        <p><LazyLoadImage src={EditPencil} /> description<sup>*</sup>:</p>
                                    </div>
                                    <div className="text-area">
                                        <textarea
                                            type="description"
                                            maxLength="2000"
                                            id="description"
                                            name="description"
                                            className="form-control"
                                            rows="3"
                                            placeholder="Describe what you would like to request..."
                                            value={message}
                                            onChange={handleMessageChange}
                                        />
                                        <p id="maxcharcter"></p>
                                        {
                                            error.message && <label id="message_error" className="error">{error.message}</label>
                                        }
                                    </div>
                                </div>
                                <input type="hidden" name="um_profile_id" id="um_profile_id" value={user.id} />
                                <div className="footer-btn">
                                    <button type="button" onClick={handleClose} className="btn theme-btn theme-btn-bordered text-uppercase">Cancel</button>
                                    <button
                                        type="submit"
                                        id="submitbtn"
                                        className="btn theme-btn theme-btn-bordered text-uppercase"
                                        disabled={error.amount || isLoading || !amount}
                                    >
                                        {
                                            isLoading ? 'Submitting...' : 'Submit'
                                        }
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PayPerViewModal;
